// Import React and ReactDOM
import React from "react";
import ReactDOM from "react-dom/client";
// Import the App component
import App from "./App";

// Use React 18's createRoot API
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
